import { DateTime } from "luxon";

export const formatDateTimeLong = (timestamp) => {
  return DateTime.fromISO(timestamp).toFormat("LL/dd/yyyy hh:mma");
};

export const formatDateTimeShort = (timestamp) => {
  return DateTime.fromISO(timestamp).toFormat("LL/dd hh:mma");
};

export const formatDateHTML = (timestamp) => {
  return DateTime.fromISO(timestamp).toFormat("yyyy-LL-dd");
};

export const formatTimeShort = (timestamp) => {
  return DateTime.fromISO(timestamp).toFormat("hh:mma");
};

export const formatTimeMilitary = (timestamp) => {
  return DateTime.fromISO(timestamp).toFormat("HH:mm");
};
export const formatTimeHtml = (timestamp) => {
  return DateTime.fromISO(timestamp).toFormat("LL-dd-yy");
};

export const formatDateShort = (timestamp) => {
  return DateTime.fromISO(timestamp).toFormat("LL/dd");
};

export const formatDateLong = (timestamp) => {
  return DateTime.fromISO(timestamp).toFormat("LL/dd/yy");
};

export const formatLabel = (text) => {
  return text
    .split("_")
    .map((word) => word.toLowerCase())
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const formatFirstLetterUpperCase = (text) => {
  return text
    .split(" ")
    .map((word) => word.toLowerCase())
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const formatCamelCaseToText = (text) => {
  const spacedString = text.replace(/([A-Z])/g, ' $1');
  return formatFirstLetterUpperCase(spacedString);
};

export const renderLocation = (entity) => {
	const { location } = entity;

	if (!location) return 'Unknown';

	const { zip, state, city, address1 } = location;

	return `${address1}, ${city} ${state}, ${zip}`;
};

export function getStatusColor(status) {
  switch (status) {
    case "Return in progress":
      return "amber";
    case "At consumer":
      return "purple";
    case "Waiting for pickup":
      return "blue";
    case "Preparing":
      return "blue-gray";
    case "Delivered":
      return "indigo";
    case "Delivery in progress":
      return "green";
    case "Placed":
      return "cyan";
    case "Voided":
      return "pink";
    case "Returned":
    case "Partially returned":
      return "orange";
    default:
      return "gray";
  }
};
